import script from "./DoocumentDetailed.vue?vue&type=script&setup=true&lang=js"
export * from "./DoocumentDetailed.vue?vue&type=script&setup=true&lang=js"

import "./DoocumentDetailed.vue?vue&type=style&index=0&id=469e8eda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-469e8eda"]])

export default __exports__